export default __webpack_public_path__ + "static/times_now_semilight-webfont-df34ac1cd5bb9ebbc4a10b622ba16e98.woff2";